/* eslint-disable max-len */
import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.OverallSatisfactionWithExperienceWithTPHealth,
        questionText: "Overall I am very satisfied with my experience with Optima Health",
        canBeDisabled: false
    },
    {
        id: questionIds.OverallSatisfactionWithExperienceWithTPHealthJustification,
        questionText: "Please let us know why you have selected the above score (please do not provide any personal identifiable information in your answer, such as any names, addresses, DOB’s, treatment dates etc.)",
        canBeDisabled: false
    },
    {
        id: questionIds.TPHealthMadeItEasyForMeToMakeAnAppointment,
        questionText: "Optima Health made it easy for me to make an appointment",
        canBeDisabled: false
    },
    {
        id: questionIds.TPHealthMadeItEasyForMeToMakeAnAppointmentJustification,
        questionText: "Please let us know why you have selected the above score (please do not provide any personal identifiable information in your answer, such as any names, addresses, DOB’s, treatment dates etc.)",
        canBeDisabled: false
    },
    {
        id: questionIds.HappinessLevelWithTheWayTheOccupationalHealthConsultationWasCarriedOut,
        questionText: "I was happy with the way the Occupational Health Appointment was carried out",
        canBeDisabled: false
    },
    {
        id: questionIds.HappinessLevelWithTheWayTheOccupationalHealthConsultationWasCarriedOutJustification,
        questionText: "Please let us know why you have selected the above score (please do not provide any personal identifiable information in your answer, such as any names, addresses, DOB’s, treatment dates etc.)",
        canBeDisabled: false
    },
    {
        id: questionIds.ReportToMyManagerWasBalancedAndImpartial,
        questionText: "I feel the report to my Manager was balanced and impartial",
        canBeDisabled: false
    },
    {
        id: questionIds.ReportToMyManagerWasBalancedAndImpartialJustification,
        questionText: "Please let us know why you have selected the above score (please do not provide any personal identifiable information in your answer, such as any names, addresses, DOB’s, treatment dates etc.)",
        canBeDisabled: false
    },
    {
        id: questionIds.HowLikelyWouldYouBeToRecommendOccupationalHealthService,
        questionText: "Considering your dealings with Optima Health how likely would you be to recommend our Occupational Health Service?",
        canBeDisabled: false
    },
    {
        id: questionIds.IfAwardedLessThanWhatCanWeDoToEarnBetterScore,
        questionText: "If you awarded less than 9, what can we do in the future to earn a score of 9 or 10?",
        canBeDisabled: false
    },
    {
        id: questionIds.DoYouFeelThatYourConsultationWithOccupationalHealthHasHelped,
        questionText: "Do you feel that your consultation with Occupational health has helped with your health and wellbeing at work?",
        canBeDisabled: false
    },
    {
        id: questionIds.DoYouFeelThatTheReportAndConsultationWillHelpYouToReturnToWork,
        questionText: "If you have received a report do you feel that the report and consultation will help you to return to work or stay at work?",
        canBeDisabled: false
    }
];
